<br>

<div class="w-100 px-2">
  <div class="input-field my-4" *ngIf="!paymentURL">
    <label class="label me-3" for="paymentLink">Clicca qui per generare il link di pagamento:</label>
    <button id="paymentLink" (click)="createPaymentLink()" class="btn btn-primary">Genera</button>
  </div>
  <div class="d-flex input-field my-4" *ngIf="paymentURL">
    <label class="label me-3 align-self-center" for="payment-link-input">Link di pagamento aggiornato:</label>
    <input style="width: 50%;" name="payment-link-input" type="text" class="form-control" [value]="paymentURL" readonly>
    <button class="btn btn-info input-end-button"><i class="bi bi-clipboard" (click)="copyToClipboard()"></i></button>
  </div>
  <mat-accordion class="w-100" [formGroup]="messages">
    <!-- hideToggle -->
    <mat-expansion-panel *ngFor="let section of sections; let i = index;" [expanded]="step === i" (opened)="setStep(i)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{getSectionTitle(i)}}
        </mat-panel-title>
        <div class="loader" style="display: none"></div>
      </mat-expansion-panel-header>
      <div class="table" *ngIf="section.id !== 0">
        <div class="row">
          <div class="cell" style="padding: 0;">
            <input type="text" placeholder="Oggetto" formControlName="{{section.subject}}" [readOnly]="section.id === 1"
              style="width: 100%;">
          </div>
          <div class="cell">
            <button class="btn btn-secondary bg-secondary text-white" style="margin-bottom: 10px"
              (click)="sendMessage(section.id, i)">Invia</button>
          </div>
        </div>
      </div>
      <div class="w-100" *ngIf="section.id !== 0">
        @if(section.id.toString() !== null){
        <app-text-editor-wrapper
          [controlText]="messages.get(section.id.toString()) | formControl"></app-text-editor-wrapper>
        }
      </div>
      <div class="d-flex align-items-center gap-1 my-3 justify-content-end">
        <button *ngIf="step !== 0" class="btn btn-secondary bg-secondary text-white"
          (click)="prevStep()">Precedente</button>
        <button *ngIf="step !== sections.length-1" class="btn btn-primary bg-primary text-white"
          (click)="nextStep()">Successivo</button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
